// Entry point for the build script in your package.json
import "@hotwired/turbo-rails"
import Rails from "@rails/ujs";
import "./controllers"
import "./plugins"
import Pikaday from "pikaday";
import dayjs from "dayjs";
import "@37signals/lexxy"

Rails.start();

document.addEventListener("turbo:load", () => {
  document.querySelectorAll(".date-picker").forEach((el) => {
    new Pikaday({
      field: el,
      format: 'YYYY-MM-DD',
      toString(date, format) {
        return dayjs(date).format(format);
      },
      parse(dateString, format) {
        return dayjs(dateString, format).toDate();
      }
    });
  });
});
